import * as React from 'react'

const classnames = require('classnames')
const isEmpty = require('lodash/isEmpty')

export interface VINProps {
  vin?: string
  className?: string
}

class VIN extends React.PureComponent<VINProps> {
  render() {
    const { vin, className } = this.props

    if (isEmpty(vin)) {
      return null
    }

    const length = vin!.length
    if (length <= 6) {
      return (
        <span className={className}>
          <b>{vin}</b>
        </span>
      )
    }

    const last6StartIndex = length - 6
    const last6 = vin!.slice(last6StartIndex, length)
    const firstChars = vin!.slice(0, last6StartIndex)

    return (
      <span className={classnames('ellipsize-left', className)}>
        {firstChars}
        <b>{last6}</b>
      </span>
    )
  }
}

export default VIN



// WEBPACK FOOTER //
// ./src/common/VIN.component.tsx